module.exports = __webpack_public_path__ + "img/202008.8abd5bb5.png";